import * as React from "react";

import "./refresh-template-modal.scss";

import {cs}            from "../../react/chain-services";
import {ModalService3} from "../modal-service-3/modal-service-3";

export const RefreshTemplateModal = ({onRefresh, next: rootNext}) => cs(
    ["modal", ({}, next) => ModalService3({
        title: <p className="refresh-template-modal">This will return your template settings to default and update the listing data.<br/>Any customization changes you have made will be lost.</p>,
        xdQaName: "Refresh Template",
        next: ({params, close}) => next({
            onClose: () => close()
        }),
        rootNext,
    })],
    ({modal}) => (
        <div className="refresh-template-modal">
             <div>
                 <p>Are you sure you want to proceed?</p>
                 <div>
                     <button
                        className="resetModalButton-hj7"
                        onClick={async () => {
                                await onRefresh();
                                modal.onClose();
                        }}
                    >
                        <i className="fa fa-refresh"/> Reset
                    </button>

                    <button
                        className="resetModalButton-hj7"
                        onClick={() => {
                            modal.onClose();
                        }}
                    >
                        <i className="fa fa-times"/> Cancel
                    </button>
                </div>
            </div>
        </div>
    ),
);
